(ns app.bundle-social-facebook.platform
  "Facebook pages through bundle.social: Reels and Stories.

   Only data and pure functions, shared by the backend (schedule
   command, push routine) and the frontend (accounts page, scheduling
   page, agenda). See `app.bundle-social.platforms` for the keys."
  (:require [ui.icons :as icons]))

(defn post-data
  "The `data.FACEBOOK` entry of a bundle.social post. A Story carries
   no text. A Reel gets the story's preview image as its cover
   (`thumbnail`)."
  [{:keys [post-type text upload-id cover-url]}]
  (cond-> {:type post-type
           :uploadIds [upload-id]}
    (and (not= "STORY" post-type)
         (seq text))
    (assoc :text text)

    cover-url
    (assoc :thumbnail cover-url)))

(def platform
  {:social-platform/id "FACEBOOK"
   :social-platform/key :facebook
   :social-platform/name "Facebook"
   :social-platform/account-noun "Facebook page"
   :social-platform/channel-noun "page"
   :social-platform/channel-nouns "pages"
   :social-platform/icon icons/facebook-logo
   :social-platform/text-class ["text-blue-600"]
   :social-platform/pill-class ["bg-blue-50" "border-blue-200" "text-blue-700"]
   :social-platform/launched? true
   ;; Meta lists pages managed through a Business Portfolio only with
   ;; the business scope, so the accounts page asks before the OAuth.
   :social-platform/business-scope? true
   :social-platform/callback-messages
   {:facebook-not-enough-pages
    "Meta did not share a Facebook page that you can post on. Reconnect and pick the page in the Meta dialog. A page managed in Meta Business Suite needs the Business Suite option."
    :facebook-not-enough-permissions
    "Meta reported that not all permissions were granted. Reconnect and keep every permission enabled."}
   :social-platform/connect-card
   {:eyebrow "Reels & Stories"
    :description "Connect a Facebook page for scheduled Reels and Stories."
    :button-text "Connect Facebook Page"
    :style {:card-class ["border-blue-200" "bg-blue-50" "hover:border-blue-300"]
            :eyebrow-class ["bg-white/70" "text-blue-600" "ring-blue-100"]
            :icon-class ["bg-white" "text-blue-600" "ring-blue-200"]
            :title-class ["text-gray-900"]
            :description-class ["text-gray-600"]
            :button-class ["bg-blue-600" "text-white" "hover:bg-blue-700"]
            :rail-class ["bg-blue-600"]}}
   :social-platform/post-data post-data
   ;; bundle.social's limits for page videos: Reels up to 20 minutes,
   ;; Stories up to 60 s.
   :social-platform/post-types
   [{:post-type/id "REEL"
     :post-type/kind :facebook-reel
     :post-type/label "Facebook Reel"
     :post-type/group-label "Facebook Reels"
     :post-type/mark "Reel"
     :post-type/media #{:video}
     :post-type/max-duration-seconds 1200
     :post-type/caption? true
     :post-type/cover? true}
    {:post-type/id "STORY"
     :post-type/kind :facebook-story
     :post-type/label "Facebook Story"
     :post-type/group-label "Facebook Stories"
     :post-type/mark "Story"
     :post-type/media #{:video}
     :post-type/max-duration-seconds 60
     :post-type/caption? false}]})
